<script setup>
  import { computed } from 'vue';
  import { useDateHelper } from "@/composables/useDateHelper";
  import { useSpotStore } from "@/stores/SpotStore";
  import { useCompleteReportStore } from '@/stores/CompleteReportStore';
  import { format, transpose } from 'date-fns';
  import { TZDate } from '@date-fns/tz'

  const dateHelper = useDateHelper();

  const spotStore = useSpotStore();
  const completeReportStore = useCompleteReportStore();

  const apiData = computed(() => spotStore.stationApiDataValues);
  
  const timestamp = computed(() => {
    if (!apiData.value.timestamp) return 'N/A';

    const localTimezone = spotStore.localTimezoneShort ?  ` ${spotStore.localTimezoneShort}` : '';
    let lastUpdateTimestamp = 'N/A';

    try {
      if (completeReportStore.lastUpdateTime === 'timestamp') {
        // const timestampInLocalTimezone =  transpose(new TZDate(new Date(apiData.value.timestamp), spotStore.localTimezone), TZDate)
        // const timestampInLocalTimezone = new TZDate(new Date(apiData.value.timestamp), spotStore.localTimezone);

        // if (!timestampInLocalTimezone) throw 'Invalid date';

        lastUpdateTimestamp = `${format(new Date(apiData.value.timestamp), 'd LLL p')}${localTimezone}`
      } else {
        const isoTimestamp = dateHelper.dateTimeToISODate(apiData.value.timestamp, spotStore.localUTCOffset);

        if (!isoTimestamp) throw 'Invalid date';

        lastUpdateTimestamp = dateHelper.timeFromNow(isoTimestamp);
      }
    } catch (e) {
      console.warn('Error parsing timestamp: ', apiData.value.timestamp, e);
    }

    return lastUpdateTimestamp;
  });
</script>

<template>
  <div>
    <p class="jwx-complete-report__last-update">Last Update: <span v-html="timestamp" class="jwx-complete-report__last-update-time"></span></p>
  </div>
</template>